import { render, staticRenderFns } from "./AdminManagementAdminsCreateModal.vue?vue&type=template&id=455eb204&scoped=true&"
import script from "./AdminManagementAdminsCreateModal.vue?vue&type=script&lang=js&"
export * from "./AdminManagementAdminsCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./AdminManagementAdminsCreateModal.vue?vue&type=style&index=0&id=455eb204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455eb204",
  null
  
)

export default component.exports